module.exports = __webpack_public_path__ + "img/success.8c74122b.png";